(function($) {
    $(() => {
        $('.team-section__card').on('mouseover', function () {
            $(this).addClass('show');
            $(this).parent().addClass('show');
        });

        $('.team-section__card').on('mouseout', function () {
            $(this).removeClass('show');
            $(this).parent().removeClass('show');
        });

        const gallery = $('.about_us-gallery');

        $('.gallery-section__image__wrapper').on('click', function () {
            gallery.find(`.slick-slide[data-slick-index="${$(this).data('index')}"] a`).click();
        });

        gallery.on('init reInit', function(event, slick) {
            $('.about_us-gallery__count').html(`1/${slick.slideCount}`);
        });

        gallery.on('afterChange', function (event, slick, currentSlide) {
            $('.about_us-gallery__count').html(`${currentSlide + 1}/${slick.slideCount}`);
        });


        gallery.slick(
            {
                infinite: true,
                slidesToShow: 4,
                arrows: true,
                nextArrow:  $('.about_us-gallery__right'),
                prevArrow:  $('.about_us-gallery__left'),
                centerMode: false,
                responsive: [
                    {
                        breakpoint: 997,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            centerPadding: '25px'
                        }
                    }
                ]
            }
        ).magnificPopup(
            {
                type: 'image',
                delegate: 'a:not(.slick-cloned)',
                closeOnContentClick: false,
                tLoading: '',
                mainClass: 'mfp-none',
                image: {
                    verticalFit: true,
                    tError: ''
                },
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    tCounter: '',
                    preload: [0,1],
                    arrowMarkup: `<img class="magnific-arrow magnific-arrow-%dir%" src="${ajax.themeurl}/assets/img/nyil.svg" />`, // markup of an arrow button
                },
                removalDelay: 0,
                callbacks: {
                    imageLoadComplete: function() {
                        var self = this;
                        setTimeout(function() { self.wrap.addClass('mfp-image-loaded'); }, 16);
                    },
                }
            }
        );

        if ($('.about_us-page').length) {
            const container = $('.isotope').isotope({
                itemSelector: '.element-item',
            });

            const initShow = 8;
            const iso = container.data('isotope');
            let counter = initShow;

            loadMore(initShow);

            $('#filters').on( 'click', 'p', function() {
                container.isotope({
                    filter: $(this).attr('data-filter')
                });
                $('#filters > p').removeClass('active');
                $(this).addClass('active');
                loadMore(initShow)
            });

            if (iso.items.length > initShow) {
                container.after(`
                    <div class="row mt-5">
                        <div class="col-lg-12 text-center">
                            <button class="btn btn-primary" id="load-more">További megjelenéseink</button>
                        </div>
                    </div>
                `);
            }


            function loadMore(toShow) {
                container.find(".hidden").removeClass("hidden");

                const hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
                    return item.element;
                });

                $(hiddenElems).addClass('hidden');
                container.isotope('layout');

                if (hiddenElems.length === 0) {
                    $("#load-more").hide();
                } else {
                    $("#load-more").show();
                }

            }

            $("#load-more").click(function() {
                if ($('#filters').data('clicked')) {
                    counter = initShow;
                    $('#filters').data('clicked', false);
                }

                counter = counter + initShow;

                loadMore(counter);
            });
        }

        const peopleSlider = $('.team-section__mobile-slider');

        peopleSlider.slick(
            {
                infinite: true,
                slidesToShow: 1,
                arrows: true,
                nextArrow:  $('.team-section__mobile-slider__right'),
                prevArrow:  $('.team-section__mobile-slider__left'),
                centerMode: false
            }
        );

        peopleSlider.on('init reInit', function(event, slick) {
            $('.team-section__mobile-slider__count').html(`1/${slick.slideCount}`);
        });

        peopleSlider.on('afterChange', function (event, slick, currentSlide) {
            $('.team-section__mobile-slider__count').html(`${currentSlide + 1}/${slick.slideCount}`);
        });

        $('.team-section__card__wrapper').on('click', function () {
            if (window.innerWidth < 991) {
                peopleSlider.slick('slickGoTo', $(this).data('slide') - 1);
                $('#peopleModal').modal('show');
            }
        });

        $('.team-section__card__close').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('#peopleModal').modal('hide');
        });



        //
        $('#about-us-left').on('click', function () {
            // $('.about_us-gallery .slick-slide:not(.slick-cloned) .gallery-slide').each(function (i) {
            // });
            $('.about_us-gallery .slick-active .gallery-slide').each(function (i) {
                // gallery.find(`.slick-slide[data-slick-index="${$(this).data('index')}"] a`).click();
                $($('.gallery-section__image')[i]).css('background-image', `url('${$(this).attr('href')}')`);
                $($('.gallery-section__image')[i]).parent().data('index', $(this).parent().parent().data('slick-index'));
            });
        });

        $('#about-us-right').on('click', function () {
            $('.about_us-gallery .slick-active .gallery-slide').each(function (i) {
                $($('.gallery-section__image')[i]).css('background-image', `url('${$(this).attr('href')}')`);
                $($('.gallery-section__image')[i]).parent().data('index', $(this).parent().parent().data('slick-index'));
            });
        });
    });
})(jQuery);